import { useLocation, useParams } from 'react-router-dom';

import { PROFILE_LINK } from '@/config/env';

function ViewProfilePage() {
  const { search } = useLocation();
  const { profile_hash_id: profileHashID } = useParams<{
    profile_hash_id: string;
  }>();
  const queryParams = new URLSearchParams(search);

  window.location.replace(
    `${PROFILE_LINK}/profile/${profileHashID}?ref=${
      queryParams.get('ref') || ''
    }`,
  );

  return null;
}

export { ViewProfilePage as default };
